import React from "react";
import "./Card.css";

function Card({ emoji, heading, detail, tone = "orange" }) {
  return (
    <article className={`card card-${tone}`}>
      <img src={emoji} alt="" />
      <h3>{heading}</h3>
      <p>{detail}</p>
    </article>
  );
}

export default Card;
